import naturalSort from "natural-order/lib/natural-sort";

export const compareNatural = naturalSort();

export function compareNaturalBy<T>(
  getValue: (value: T) => string | null | undefined
) {
  return (a: T, b: T) => compareNatural(getValue(a) || "", getValue(b) || "");
}
